import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { AnalyticsLayoutWrapperPage } from '@ui-seeker/app'

import { SESSIONS_ROUTES } from '@constants'
import { useUserApp } from '@hooks'
import PageWrapperActions from './Actions'
import { AppOfficesModal, AppSitesModal } from '@components'


export default function PageWrapper({ children, actions, showReportsSelect = false, directsite = null, showAnalyzersLinks = false, ...props }) {
	const { pathname, search, hash } = useLocation()
	const { isLogged } = useUserApp()
	const testingBanner = window.location.host.includes('testing.') ? [{
		title: 'TESTING',
		message: 'This is a testing environment. Please do not use for production purposes.',
		severity: 'info',
	}] : []


	if (!isLogged)
		return <Navigate to={`${SESSIONS_ROUTES.LOGIN_URL}?redirect=${encodeURIComponent(pathname + search + hash)}`} replace/>

	return <AnalyticsLayoutWrapperPage
		globalMessages={testingBanner}
		actions={!actions ? <PageWrapperActions
			showReportsSelect={showReportsSelect}
			showAnalyzersLinks={showAnalyzersLinks}
			directsite={directsite}/> : actions}
		reportSelectorProps={props.reportSelectorProps}
		noDataProps={{
			imageProps: {
				width: '20%',
			},
		}}
		showLinkButton={false}
		{...props}
	>
		<AppOfficesModal/>
		<AppSitesModal/>
		{children}
	</AnalyticsLayoutWrapperPage>
}